import { useReducer, useMemo, Dispatch } from 'react';

import {
    SetShouldShowBadgePayload,
    SetVaultItemPayload,
    SetVaultItemsPayload,
    VaultState,
} from './types';

import useAction from '../../hooks/useAction';

import reducer, { defaultState } from './reducer';

import {
    setVaultItems as setVaultItemsAction,
    setVaultItem as setVaultItemAction,
    setShouldShowBadge as setShouldShowBadgeAction,
    SetVaultItemsAction,
    SetVaultItemAction,
    SetShouldShowBadgeAction,
    VaultAction,
} from './actions';

export interface VaultActions {
    setVaultItems: (payload: SetVaultItemsPayload) => void;
    setVaultItem: (payload: SetVaultItemPayload) => void;
    setShouldShowBadge: (payload: SetShouldShowBadgePayload) => void;
}

export interface SubscriptionVaultState {
    state: VaultState;
    actions: VaultActions;
}

function useActions(dispatch: Dispatch<VaultAction>): VaultActions {
    const setVaultItems = useAction<SetVaultItemsPayload, SetVaultItemsAction>(
        dispatch,
        setVaultItemsAction,
    );
    const setVaultItem = useAction<SetVaultItemPayload, SetVaultItemAction>(
        dispatch,
        setVaultItemAction,
    );
    const setShouldShowBadge = useAction<SetShouldShowBadgePayload, SetShouldShowBadgeAction>(
        dispatch,
        setShouldShowBadgeAction,
    );

    return useMemo(
        () => ({
            setVaultItems,
            setVaultItem,
            setShouldShowBadge,
        }),
        [setVaultItems, setVaultItem, setShouldShowBadge],
    );
}

function useVaultState(): SubscriptionVaultState {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const actions = useActions(dispatch);

    return useMemo(
        () => ({
            state,
            actions,
        }),
        [state, actions],
    );
}

export default useVaultState;
